<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard no-header>
        <CCardBody>
          <CForm v-if="user">
            <template slot="header">
              Edit User id:  {{ $route.params.id }}
            </template>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
            <CInput type="text" label="Name" id="company" placeholder="Name" v-model="user.name"></CInput>
            <CInput type="text" label="Email" id="email" placeholder="Email" v-model="user.email"></CInput>
            <div>
              <label>User Type</label>
              <v-select 
                v-if="roles"
                v-model="user.user_type"
                :options="['csr', 'rep', 'universal_rep', 'admin', 'admin_assistant']"
                placeholder="User Type"
              />
            </div>
            <CInput type="text" style="margin-top:15px;" label="CSR Code (if any)" id="csr_code" placeholder="CSR Code" v-model="user.csr_code"></CInput>
            <CInput type="text" style="margin-top:15px;" label="Rep # (if any)" id="rep_num" placeholder="Rep #" v-model="user.rep_number"></CInput>
            <CInput type="text" style="margin-top:15px;" label="NetSuite Internal ID" id="internal_id" placeholder="Internal ID..." v-model="user.internal_id"></CInput>

            <div>
              <label>User References (links user to all orders & artwork of selected user)</label>
              <table class="table" style="width:400px;">
                <thead>
                  <tr>
                    <th>User</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="user.user_references">
                  <tr v-for="(r, index) in user.user_references">
                    <td v-if="!r.edit">{{r.ref_user.name}}</td>
                    <td v-else>
                      <!-- <input type="text" placeholder="Insert Rep Number..." class="form-control" v-model="r.rep_user" /> -->
                      <v-select :options="allUsers" label="name" v-model="r.ref_user"></v-select>
                    </td>
                    <td>
                      <CButton size="sm" color="danger" @click="removeRepReference(r, index)">Remove</CButton>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td colspan="2" class="text-center">
                      <CButton size="sm" color="success" @click="addRepReference()">Add Reference</CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <v-select 
                v-if="roles"
                v-model="user.menu_roles"
                :options="roles"
                placeholder="Menu Roles"
                multiple
              /> -->
            </div>

            <div>
              <label>Menu Roles</label>
              <v-select 
                v-if="roles"
                v-model="user.menu_roles"
                :options="roles"
                placeholder="Menu Roles"
                multiple
              />
            </div>

            <div style="margin-top:15px;">
              <label>Distributor?</label>
              <div>
                <CButton size="sm" @click="user.distributor = 1" :color="user.distributor === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="user.distributor = 0" style="margin-left:5px;" :color="user.distributor === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div style="margin-top:15px;">
              <label>See other rep's orders that are with this user?</label>
              <div>
                <CButton size="sm" @click="user.see_other_rep_orders = 1" :color="user.see_other_rep_orders === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="user.see_other_rep_orders = 0" style="margin-left:5px;" :color="user.see_other_rep_orders === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 mb-3 p-0">
              <label>Min Does Not Matter (for min quantity of order)</label>
              <div>
                <CButton size="sm" @click="user.min_does_not_matter = 1" :color="user.min_does_not_matter === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="user.min_does_not_matter = 0" style="margin-left:5px;" :color="user.min_does_not_matter === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 mb-3 p-0">
              <label>Allow Fast Lane</label>
              <div>
                <CButton size="sm" @click="user.allow_fast_lane = 1" :color="user.allow_fast_lane === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="user.allow_fast_lane = 0" style="margin-left:5px;" :color="user.allow_fast_lane === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="mt-3">
              <label>Status</label>
              <v-select
                v-model="user.status"
                :options="['Active', 'Banned', 'Pending', 'not_activated']"
                placeholder="Status"
              />
            </div>

            <div style="margin-top:15px;">
              <label>Timezone</label>
              <v-select
                v-model="user.timezone"
                :options="['CST', 'EST', 'PST']"
                placeholder="Timezone"
              />
            </div>

            <div style="margin-top:15px;">
              <label>Only See Program(s)</label>
              <v-select
                v-if="programOptions"
                v-model="user.only_programs"
                value="program_id"
                label="program_name"
                :options="programOptions"
                multiple
                placeholder="Select if you want user to only see selected programs."
              />
            </div>

            <spacer />

            <div style="margin-top:15px;">
              <CButton color="danger" size="sm" @click="resetPassword()">Reset Password & Send Email</CButton>
            </div>

            <CInput type="text" style="margin-top:15px;" label="Reset Password" id="password" placeholder="Reset Password.." v-model="password"></CInput>
            <CButton color="primary" @click="update()">Save</CButton>
            <CButton color="primary" class="ml-2" @click="goBack">Back</CButton>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
export default {
  name: 'EditUser',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
        name: '',
        email: '',
        showMessage: false,
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        password: '',
        roles: null,
        programOptions: null,
        userReferenceChanged: false,
        allUsers: '',
        user: {
          id: '',
          name: '',
          email: '',
          menu_roles: '',
          user_type: '',
          rep_number: '',
          timezone: '',
          csr_code: '',
          min_does_not_matter: '',
          allow_fast_lane: 0,
          status: '',
          distributor: '',
          see_other_rep_orders: '',
          only_programs: '',
          user_references: '',
          internal_id: ''
        }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    addRepReference() {
      console.log('rep ref clicked')
      // console.log(this.user.rep_references)
      if (!this.user.user_references) {
        this.user.user_references = []
      }
      var obj = {
        id: '',
        rep_number: '',
        user_id: this.user.id,
        ref_user: '',
        edit: true
      }
      this.user.user_references.push(obj)
      this.userReferenceChanged = true
      console.log(this.user)
    },
    getPrograms() {
      let self = this
      axios.get( this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        console.log(response)
        // self.programOptions = response.data
        
        self.programOptions = response.data
        var arr = []
        if (self.user.only_programs) {
          self.programOptions.forEach(function (val) {
            if (self.user.only_programs.indexOf(val.program_id) > -1) {
              arr.push(val)
            }
          })
        }
        self.user.only_programs = arr
      }).catch(function (error) {
        console.log(error)
      });
    },
    resetPassword() {
      axios.post( this.$apiAdress + '/api/resetPasswordRequest', {
        email: this.user.email,
      }).then(response => {
        console.log('success')
        console.log(response)
        this.message = 'You have been sent an email to reset your password.'
        window.Swal.fire({
          type: 'success',
          title: 'Success!',
          text: 'You have sent them an email to reset their password.'
        })
      }).catch(e => {

      });
    },
    update() {
        console.log(this.user)
        let self = this;
        axios.post( this.$apiAdress + '/api/users/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            name: self.user.name,
            email: self.user.email,
            user_type: self.user.user_type,
            rep_number: self.user.rep_number,
            menu_roles: self.user.menu_roles,
            timezone: self.user.timezone,
            password: self.password,
            csr_code: self.user.csr_code,
            status: self.user.status,
            min_does_not_matter: self.user.min_does_not_matter,
            allow_fast_lane: self.user.allow_fast_lane,
            see_other_rep_orders: self.user.see_other_rep_orders,
            distributor: self.user.distributor,
            only_programs: self.user.only_programs,
            internal_id: self.user.internal_id,
            user_references: self.user.user_references,
            userReferenceChanged: self.userReferenceChanged
        })
        .then(function (response) {
            self.message = 'Successfully updated user.';
            self.showAlert();
        }).catch(function (error) {
            console.log(error);
            // self.$router.push({ path: '/login' });
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getAllUsers() {
      axios.get(this.$apiAdress + '/api/getAllUsers?token=' + localStorage.getItem('api_token')).then(response => {
        console.log(response)
        // this.roles = response.data
        var that = this
        this.allUsers = response.data
      })
    },
    getRoles() {
      axios.get(this.$apiAdress + '/api/roles?token=' + localStorage.getItem('api_token')).then(response => {
        console.log(response)
        // this.roles = response.data
        var that = this
        this.roles = []
        response.data.forEach(function (val) {
          that.roles.push(val.name)
        })
      })
    }
  },
  mounted: function(){
    let self = this;
    // this.getAllUsers()
    axios.get( this.$apiAdress + '/api/users/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      console.log(response)
        self.user.name = response.data.name
        self.user.id = response.data.id
        self.user.email = response.data.email
        self.user.user_type = response.data.user_type
        self.user.rep_number = response.data.rep_number
        self.user.timezone = response.data.timezone
        self.user.csr_code = response.data.csr_code
        self.user.status = response.data.status
        self.user.min_does_not_matter = response.data.min_does_not_matter
        self.user.allow_fast_lane = parseInt(response.data.allow_fast_lane || 0)
        self.user.see_other_rep_orders = response.data.see_other_rep_orders
        self.user.distributor = response.data.distributor
        self.user.user_references = response.data.user_references
        self.user.only_programs = response.data.only_programs
        self.user.internal_id = response.data.internal_id
        var arr = response.data.menu_array
        self.user.menu_roles = []
        arr.forEach(function (val) {
          self.user.menu_roles.push(val)
        })
        self.getPrograms()
        self.getAllUsers()
    }).catch(function (error) {
        console.log(error);
        // self.$router.push({ path: '/login' });
    });
    this.getRoles()
  }
}


</script>
